import React, { FC } from 'react';

import {
  DateField,
  DateFieldProps,
} from 'react-admin';

interface IConfigVersionDateTimeFieldProps extends Pick<DateFieldProps, 'source'> {}

const ConfigVersionDateTimeField: FC<IConfigVersionDateTimeFieldProps> = ({ source }) => (
  <DateField
    source={source}
    locales="en-US"
    options={{
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZoneName: 'short',
    }}
  />
);

export default ConfigVersionDateTimeField;